<template>
  <div :class="generalStore.iFrame ? 'min-h-screen' : 'min-h-screen bg-brand-50'">
    <div :class="generalStore.iFrame ? 'justify-center items-center' : 'p-5 justify-center items-center'">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGeneralStore } from '../stores/general';

const generalStore = useGeneralStore();

defineProps<{
  image?: string;
}>();

if (window.self !== window.top) {
  generalStore.iFrame = true;
} else {
  generalStore.iFrame = false;
}
</script>

<style scoped lang="scss">
@use '@/styling/global.scss' as *;

.backBtn {
  font-size: 20px;
  position: relative !important;
  top: 30px !important;
}
span.text-left {
  display: none;
}
@media only screen and (max-width: $bp-mobile) {
  span.text-left {
    display: block;
    top: 5%;
    position: absolute;
  }
}
</style>
